module.exports = __webpack_public_path__ + "img/disabled-product-icon.c20d85c0.svg";